
import enLocale from 'element-ui/lib/locale/lang/en'//英文
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'//中文
import deLocale from 'element-ui/lib/locale/lang/de'//德语
import esLocale from 'element-ui/lib/locale/lang/es'//西班牙语
import thLocale from 'element-ui/lib/locale/lang/th'//泰语
import koLocale from 'element-ui/lib/locale/lang/ko'//韩语
import jaLocale from 'element-ui/lib/locale/lang/ja'//日语

const messages = {
  enUS:{
    list:{},
    ...enLocale
  },
  zhCN:{
    list:{},
    ...zhLocale
  },
  deDE:{
    list:{},
    ...deLocale
  },
  esES:{
    list:{},
    ...esLocale
  },
  thTH:{
    list:{},
    ...thLocale
  },
  koKR:{
    list:{},
    ...koLocale
  },
  jaJP:{
    list:{},
    ...jaLocale
  }
}
export default messages


// WEBPACK FOOTER //
// ./src/i18n/langs/languages.js